import { Trans } from 'react-i18next'
import NotificationBar from '~/components/NotificationBar'
import { useCalcSettlementFeeRisk } from '~/components/Exchange/hooks'

interface Props {
  fee: bigint
}

const SettlementFeeRiskCalculator: React.FC<Props> = ({ fee = 0n }) => {
  const { level, percentage } = useCalcSettlementFeeRisk(fee)

  if (level === 'info') return null

  return (
    <NotificationBar
      level="warning"
      text={
        <Trans
          i18nKey="settlement_fee_risk_alert"
          values={{ percentage: percentage.toFixed(1) }}
          components={{
            special: <span style={{ fontWeight: 700 }}>{percentage}%</span>,
          }}
        />
      }
      showIcon={false}
      showLink={false}
      showClose={false}
      style={{ marginTop: '8px' }}
    />
  )
}

export default SettlementFeeRiskCalculator
